import React from 'react';
import PropTypes from 'prop-types';

export default class SuscSummary extends React.Component {

  static propTypes = {
    rawDataCollection: PropTypes.object.isRequired,
  };

  get summary() {
    const {rawDataCollection} = this.props;
    const {rawSuscResults} = rawDataCollection;

    const summary = rawSuscResults.reduce((accu, susc) => {
      const drugName = susc.drugName;
      if (drugName) {
        accu[drugName] = accu[drugName] || 0;
        accu[drugName] += 1;
      }
      return accu;
    }, {});

    const spliter = ';' + ' ';
    const summary_length = Object.entries(summary).length;

    return (
      <span>
        {Object.entries(summary).map(([drugName, number], idx) => {
          const showSpliter = (idx < (summary_length - 1));
          return (
            <span key={idx}>
              {drugName}{' '}({number})
              {showSpliter? spliter: null}
            </span>
          );
        })}
      </span>
    );
  }

  render() {
    return (
      <div>
        <h3>
          Susceptibility summary:
        </h3>
        <p>{this.summary}</p>
        <hr/>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/wizard/susc-results/gtable/susc-summary.js